import { DataBlock } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { v4 } from 'uuid'
import ActionButton from '../helpers/ActionButton'
import ItemBlock from '../helpers/ItemBlock'
import SectionDivider from '../helpers/SectionDivider'
import SectionHeading from '../helpers/SectionHeading'
import RelationshipPersonBlock from './RelationshipPersonBlock'

export default function SpousesAndChildren({ person, actionButtonOnClick }) {
  const { t } = useTranslation()
  return (
    <>
      {person.spousesAndChildren.map((spouseAndChildren, index) => {
        const actionButtonOnClickSpouseAndChildren = (item, actionButtonType, childIndex) => {
          actionButtonOnClick({ item, actionButtonType, index, childIndex })
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={`${spouseAndChildren.spouse.relationshipId}${person.isSurvivingPerson}${index}`}>
            <SectionHeading heading={t('tools.adminMerge.headings.spouseAndChildren', 'Family: Spouse and Children')} />
            <ItemBlock
              selected={spouseAndChildren.spouse.actionButtonType === 'UNDO'}
              displayStatus={spouseAndChildren.spouse.displayStatus}
              isSurvivingPerson={person.isSurvivingPerson}
            >
              <DataBlock
                heading={
                  spouseAndChildren.spouse?.noSpouse
                    ? `${t('no', 'No')} ${t('spouse', 'Spouse')}`
                    : t('spouse', 'Spouse')
                }
                data={
                  !spouseAndChildren.spouse?.noSpouse && (
                    <RelationshipPersonBlock person={spouseAndChildren.spouse.value} />
                  )
                }
              />
              <ActionButton
                type={spouseAndChildren.spouse.actionButtonType}
                onClick={() =>
                  actionButtonOnClickSpouseAndChildren('Spouse', spouseAndChildren.spouse.actionButtonType)
                }
              />
            </ItemBlock>
            {spouseAndChildren.children &&
              spouseAndChildren.children.map((child, childIndex) => {
                return (
                  <ItemBlock
                    key={child.value ? child.value.relationshipId : v4()}
                    selected={child.actionButtonType === 'UNDO'}
                    displayStatus={child.displayStatus}
                    isSurvivingPerson={person.isSurvivingPerson}
                  >
                    <DataBlock
                      heading={t('child', 'Child')}
                      data={<RelationshipPersonBlock person={child.value?.child} />}
                    />
                    <ActionButton
                      type={child.actionButtonType}
                      onClick={() => actionButtonOnClickSpouseAndChildren('Child', child.actionButtonType, childIndex)}
                    />
                  </ItemBlock>
                )
              })}
            <SectionDivider />
          </React.Fragment>
        )
      })}
    </>
  )
}
